import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Bell, Clock } from 'lucide-react';
import { trackAddToCart } from './MetaPixel';
export function Header() {
  const [isVisible, setIsVisible] = useState(true);
  // Hide notification after some scrolling
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 500) {
        setIsVisible(false);
      } else {
        setIsVisible(true);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <header className="sticky top-0 z-50 bg-white shadow-sm" data-id="element-312">
      {isVisible && <motion.div className="bg-red-600 text-white py-0 text-center text-sm font-medium" initial={{
      y: -50,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} transition={{
      duration: 0.5
    }} data-id="element-313">
          <motion.div className="container mx-auto px-4 flex items-center justify-center gap-2" animate={{
        scale: [1, 1.03, 1]
      }} transition={{
        repeat: Infinity,
        duration: 2
      }} data-id="element-314">
            <Bell size={14} data-id="element-315" />
            <span className="text-xs" data-id="element-316">
              ¡ALERTA! Solo quedan 17 unidades disponibles al precio promocional
            </span>
            <Clock size={14} data-id="element-317" />
          </motion.div>
        </motion.div>}
    </header>;
}